import styled from 'styled-components';

import {
  colorBlack100,
  colorBorder,
  colorPrimary400,
  colorSecondary400,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  HoverState,
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
  mediaQueryMobileMin,
  SectionStyles,
} from '@/styleUtils';

export const Wrapper = styled.div`
  ${SectionStyles};
  border-radius: 8px 8px 0 0;
`;

export const StaticContentSection = styled.section`
  padding: 32px 16px;
  box-shadow: 0 -1px 0 0 ${colorBorder} inset;
  display: flex;
  flex-direction: column;
  @media ${mediaQueryMobileLargeMin} {
    padding: 32px 24px;
  }
  @media ${mediaQueryLaptopMin} {
    padding: 48px 24px;
  }
`;
export const SectionItems = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 16px;
  @media ${mediaQueryMobileLargeMin} {
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    row-gap: 24px;
  }
  @media ${mediaQueryLaptopMin} {
    margin-top: 24px;
  }
`;
export const WhyApplyItem = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: self-start;
  gap: 16px;
  svg {
    flex-shrink: 0;
  }
`;
export const HowChooseItem = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 16px;
  padding: 16px;
  text-align: left;
  border: 1px solid ${colorBorder};
  @media ${mediaQueryMobileMin} {
    padding: 24px;
  }
`;
export const Hint = styled.span`
  font: 700 12px/16px ${fontFamilySecondary};
  color: ${colorWhite};
  padding: 0 8px;
  border-radius: 23px;
  background-color: ${({ $red }) =>
    $red ? colorSecondary400 : colorPrimary400};
  width: max-content;
`;
export const Image = styled.img`
  width: 56px;
`;
export const StaticContentTitle = styled.h2`
  font: 700 20px/28px ${fontFamilyPrimary};
  @media ${mediaQueryMobileMin} {
    font-size: 24px;
    line-height: 32px;
  }
  ${({ $marginTop }) => ($marginTop ? `margin-top: ${$marginTop}px;` : '')}
  ${({ $marginBottom }) =>
    $marginBottom ? `margin-bottom: ${$marginBottom}px;` : ''}
`;
export const StaticContentText = styled.p`
  a {
    color: ${colorPrimary400};
    ${HoverState}
  }
  font: 400 14px/24px ${fontFamilySecondary};
`;
export const StyledStaticContentText = styled(StaticContentText)`
  font: 700 18px/24px ${fontFamilyPrimary};
`;
export const StyledStaticContentDescription = styled(StaticContentText)`
  line-height: 20px;
`;

export const StyledItem = styled(StaticContentText)`
  display: flex;
  align-items: flex-start;
  &:first-of-type {
    margin-top: 16px;
  }
  svg {
    color: ${colorBlack100};
    margin-right: 8px;
  }
`;
export default Wrapper;
